import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Input,

    DatePicker,
    Select,

} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import * as XLSX from "xlsx";
import moment from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;
const Search = Input.Search;
function ViewRide() {
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [listExport, setListExport] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);

    const [selected, setSelected] = useState();

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [filter, setFilter] = useState();
    const [hotelId, setHotelId] = useState();
    const debouncedSearchText = useDebounce(searchText, 300);
    const params = useParams()
    const { confirm } = Modal;


    const onSearch = (e) => {
        setSearchText(e.target.value);
        setPagination({ current: 1 });
    };

    useEffect(() => {
        setHotelId(params.id)
    }, [params])



    const columns = [
        {
            title: "Customer Name",
            render: (_, { customerName }) => {
                return <div>{customerName ? customerName : '--'}</div>;
            },
        },
        {
            title: "Customer Contact",
            render: (_, { customerPhoneNumber, customerCountryCode }) => {
                return <div>{customerPhoneNumber ? "+" + customerCountryCode + "-" + customerPhoneNumber : '--'}</div>;
            },
        },
        {
            title: "Hotel Name",
            render: (_, { hotel }) => {
                return <div>{hotel ? hotel.name : '--'}</div>;
            },
        },
        {
            title: "Ride Type",
            render: (_, { rideType }) => {
                return <div>{rideType}</div>;
            },
        },
        {
            title: "Payment Type",
            render: (_, { paymentType }) => {
                return <div>{paymentType}</div>;
            },
        },
        {
            title: "Ride date",
            key: "created_at",
            dataIndex: "created_at",
            render: (_, { created_at }) => {
                return new Date(created_at).toLocaleDateString();
            },
        },

    ];
    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [refresh, debouncedSearchText, startDate, endDate]);

    const handleChange = (pagination, filters) => {
        setFilter(filters.is_active);
        fetchData(pagination, filters);
    };
    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.is_status : null;
        request({
            url: `/admin/ride/list?id=${params.id}&status=${filterActive ? filterActive.join(",") : ""
                }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
                }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
                }&end_date=${endDate ? endDate : ""}`,
            method: "GET",
            onSuccess: (data) => {
                setLoading(false);
                setList(data.data.list.docs);
                setPagination((prev) => ({
                    current: pagination.current,
                    total: data.data.list.totalDocs,
                }));
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };
    const handleChangeDate = (e) => {
        setStartDate();
        setEndDate();
        if (e && e.length > 0) {
            setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
            setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
        }
    };

    return (
        <Main>
            <div className="tabled">
                <Row>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Hotel Ride  Management"
                            extra={
                                <>
                                    <Search
                                        size="large"
                                        onChange={onSearch}
                                        value={searchText}
                                        onPressEnter={onSearch}
                                    />
                                    <RangePicker onChange={handleChangeDate} />

                                    <Button
                                        onClick={(e) => {
                                            setVisible(true);
                                            setSearchText("");
                                        }}
                                    >
                                        Add Hotel Ride
                                    </Button>
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={pagination}
                                    onChange={handleChange}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            {visible && (
                <AddFrom
                    show={visible}
                    hide={() => {
                        setSelected();
                        setVisible(false);
                        setSearchText("");
                    }}
                    data={hotelId}
                    refresh={() => setRefresh((prev) => !prev)}
                />
            )}

        </Main>
    );
}

const AddFrom = ({ show, hide, data, refresh }) => {
    const [mobileNumber, setMobileNumber] = useState({
        mobile: "",
        country_code: "",
    });

    const [form] = Form.useForm();
    const { request } = useRequest();

    const [loading, setLoading] = useState(false);

    const onChange = (e) => console.log(`radio checked: ${e.target.value}`);

    const onCancel = (e) => hide();

    const handleChange = (value, data, event, formattedValue) => {
        var country_code = data.dialCode;
        setMobileNumber({
            country_code: country_code,
            mobile: value.slice(data.dialCode.length),
        });
    };
    useEffect(() => {
        if (!data) return;
        form.setFieldsValue({ ...data });
        setMobileNumber({
            mobile: data.mobileNumber,
            country_code: data.countryCode,
        });
    }, [data]);

    const onCreate = (values) => {
        const { customerName,
            pickupAddress,
            destinationAddress,
            hotel,
            paymentType,
            rideTypes, } = values;
        const payload = {};
        if (!mobileNumber.mobile) return ShowToast('Please enter mobile number ', Severty.ERROR)
        if (((mobileNumber.mobile).length <= 6 || (mobileNumber.mobile).length >= 15)) {
            return ShowToast('Please enter 7 to 12 digits', Severty.ERROR);
        }
        setLoading(true);
        payload.customerName = customerName;
        payload.destinationAddress = destinationAddress;
        payload.customerCountryCode = mobileNumber.country_code
        payload.customerPhoneNumber = mobileNumber.mobile
        payload.pickupAddress = pickupAddress
        payload.hotel = data
        payload.paymentType = paymentType
        payload.rideTypes = rideTypes
        request({
            url: `${data
                ? `/admin/ride/add`
                : `/admin/ride/add`
                }`,
            method: `${data ? "POST" : "POST"}`,
            data: payload,
            onSuccess: (data) => {
                setLoading(false);
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS);
                    hide();
                    refresh();

                } else {
                    ShowToast(data.message, Severty.ERROR);
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR);

                setLoading(false);
            },

        });

    };

    return (
        <Modal
            visible={show}
            title={`Ride Management`}
            okText="Ok"
            onCancel={hide}
            okButtonProps={{
                form: "create",
                htmlType: "submit",
                loading: loading,
            }}
        >
            <Form id="create" form={form} onFinish={onCreate} layout="vertical">
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label="Customer Name"
                            name="customerName"
                            rules={[
                                { required: true, message: "Please input the name!" },

                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Pickup Point"
                            name="pickupAddress"
                            rules={[
                                { required: true, message: "Please Enter the Pickup Address!" },

                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Destination Point"
                            name="destinationAddress"
                            rules={[
                                { required: true, message: "Please Enter the Destination Address!" },

                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Customer Number"
                        >
                            <PhoneInput inputProps={{
                                name: "mobile",
                                required: true,
                                autoFocus: false,
                            }}
                                isValid={(value, country) => {
                                    if (value.match(/1234/)) {
                                        return 'Invalid value: ' + value + ', ' + country.name;
                                    } else if (value.match(/1234/)) {
                                        return 'Invalid value: ' + value + ', ' + country.name;
                                    } else {
                                        return true;
                                    }
                                }}
                                country={"kw"} value={mobileNumber ? ((mobileNumber.country_code ? mobileNumber.country_code : "+354") + (mobileNumber.mobile ? mobileNumber.mobile : null)) : ''} onChange={handleChange} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Payment Type"
                            name="paymentType"
                            rules={[
                                { required: true, message: "Please input the Contact name!" },

                            ]}
                        >
                            <Select placeholder="Select Payment Type">
                                <Option value="Cash">Cash</Option>
                                <Option value="ByHotel">ByHotel</Option>

                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="rideType" label="Ride Type">
                            <Select placeholder="Select Ride Type">
                                <Option value="Now">Now</Option>
                                <Option value="Scheduled">Scheduled</Option>

                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
            </Form>
        </Modal>
    );
};






export default ViewRide;
